// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__dryPx","requiredAsterisk":"Info_requiredAsterisk__3P-Nl"};